import { render, staticRenderFns } from "./CellRenderProfile.vue?vue&type=template&id=29c25efc&scoped=true&"
import script from "./CellRenderProfile.vue?vue&type=script&lang=js&"
export * from "./CellRenderProfile.vue?vue&type=script&lang=js&"
import style0 from "./CellRenderProfile.vue?vue&type=style&index=0&id=29c25efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c25efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VList,VListItem,VListItemAvatar,VListItemTitle})
